import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseActivityEntity } from './activity-history/base-activity.entity';
import { ClientEntity } from './client.entity';

@Index('idx_ca_client_created', ['fkClientId', 'createdDate'], {})
@Index('idx_ca_type', ['activityType'], {})
@Index('idx_ca_user', ['fkUserId'], {})
@Entity('client_activity')
export class ClientActivityEntity extends BaseActivityEntity {
	@Column('int', { name: '_fk_client__id', unsigned: true })
	public fkClientId!: number;

	@ManyToOne(() => ClientEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_client__id', referencedColumnName: 'id' }])
	public fkClient!: ClientEntity;
}
